<div role="alertdialog" aria-labelledby="title" aria-describedby="desc">
  <div class="d-flex header" [class.rtl]="rightToLeftSite" id="title">
    <img *ngIf="data.isWarning" class="image" src="assets/images/shared/warning-icon.svg" alt="Warning" />
    <h1 *ngIf="data.title" mat-dialog-title>{{ data.title | translate }}</h1>
  </div>
  <div *ngIf="data.body" mat-dialog-content id="desc">{{ data.body | translate }}</div>
  <div mat-dialog-actions class="options-button-group" [class.rtl]="rightToLeftSite">
    <button *ngIf="data.cancelButton" mat-raised-button (click)="selected(false)">
      {{ data.cancelButton | translate }}
    </button>
    <button *ngIf="data.okButton" color="primary" class="okButton" mat-raised-button (click)="selected(true)">
      {{ data.okButton | translate }}
    </button>
  </div>
  <button
    *ngIf="data.isCloseIconVisible"
    mat-icon-button
    aria-label="Close"
    class="close-icon-wrapper"
    [class.rtl]="rightToLeftSite"
    (keyup.enter)="selected(true)"
    (click)="selected(true)"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
